export const SKILLS = [
  {
    title: "Frontend",
    icon: "/assets/images/programmer_11184385.png", // Corrected path
    skills: [
      { skill: "HTML5", percentage: "88%" },
      { skill: "CSS3 (Sass/SCSS)", percentage: "98%" }, // Fixed the key name from 'skills' to 'skill'
      { skill: "JavaScript", percentage: "75%" }, // Fixed typo
      { skill: "React.js", percentage: "88%" },
    ],
  },
  {
    title: "Backend",
    icon: "/assets/images/html_14661237.png", // Corrected path
    skills: [
      { skill: "Node.js", percentage: "70%" },
      { skill: "Express.js", percentage: "60%" },
    ],
  },
  {
    title: "Tools",
    icon: "/assets/images/setting_6467523.png", // Corrected path
    skills: [
      { skill: "Git & GitHub", percentage: "75%" },
      { skill: "Visual Studio Code", percentage: "85%" },
      { skill: "Webpack", percentage: "60%" },
      { skill: "Responsive Design", percentage: "70%" },
    ],
  },
  {
    title: "Soft Skills",
    icon: "/assets/images/thinking_15543231.png", // Corrected path
    skills: [
      { skill: "Problem Solving", percentage: "88%" },
      { skill: "Collaboration", percentage: "75%" }, // Fixed typo
      { skill: "Attention to Detail", percentage: "88%" },
    ],
  },
];

export const WORK_EXPERIENCE = [
  {
    title: "Senior Frontend at Tech Innvoters",
    date: "January 2022 -Present",
    responsibilities: [
      " Lorem Ipsum is simply dummy text of the printing and typesetting industry.", 
      "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
       "It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    ],
  },
  {
    title:"Junior Web Developer at Digital Solution",
    date:"June  2020 -December 2021",
    responsibilities: [
      " Lorem Ipsum is simply dummy text of the printing and typesetting industry.", 
      "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
       "It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    ],    
  },
  {
    title:"Frontend  Intern at web Studio",
    date:"May 2019 - August 2019",
    responsibilities: [
      " Lorem Ipsum is simply dummy text of the printing and typesetting industry.", 
      "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
       "It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    ],
  },
];
